export default "__VITE_ASSET__b8d85d33__"